__turbopack_context__.v({
  "icon": "a-list-item-module-scss-module__ZU61ja__icon",
  "icon-color-aqua": "a-list-item-module-scss-module__ZU61ja__icon-color-aqua",
  "icon-color-background-gray": "a-list-item-module-scss-module__ZU61ja__icon-color-background-gray",
  "icon-color-berry": "a-list-item-module-scss-module__ZU61ja__icon-color-berry",
  "icon-color-black": "a-list-item-module-scss-module__ZU61ja__icon-color-black",
  "icon-color-dark-aqua": "a-list-item-module-scss-module__ZU61ja__icon-color-dark-aqua",
  "icon-color-dark-berry": "a-list-item-module-scss-module__ZU61ja__icon-color-dark-berry",
  "icon-color-dark-gray": "a-list-item-module-scss-module__ZU61ja__icon-color-dark-gray",
  "icon-color-dark-green": "a-list-item-module-scss-module__ZU61ja__icon-color-dark-green",
  "icon-color-dark-moss": "a-list-item-module-scss-module__ZU61ja__icon-color-dark-moss",
  "icon-color-dark-orange": "a-list-item-module-scss-module__ZU61ja__icon-color-dark-orange",
  "icon-color-dark-red": "a-list-item-module-scss-module__ZU61ja__icon-color-dark-red",
  "icon-color-dark-smoke": "a-list-item-module-scss-module__ZU61ja__icon-color-dark-smoke",
  "icon-color-faded-aqua": "a-list-item-module-scss-module__ZU61ja__icon-color-faded-aqua",
  "icon-color-faded-berry": "a-list-item-module-scss-module__ZU61ja__icon-color-faded-berry",
  "icon-color-faded-gray": "a-list-item-module-scss-module__ZU61ja__icon-color-faded-gray",
  "icon-color-faded-green": "a-list-item-module-scss-module__ZU61ja__icon-color-faded-green",
  "icon-color-faded-moss": "a-list-item-module-scss-module__ZU61ja__icon-color-faded-moss",
  "icon-color-faded-red": "a-list-item-module-scss-module__ZU61ja__icon-color-faded-red",
  "icon-color-faded-smoke": "a-list-item-module-scss-module__ZU61ja__icon-color-faded-smoke",
  "icon-color-gray": "a-list-item-module-scss-module__ZU61ja__icon-color-gray",
  "icon-color-green": "a-list-item-module-scss-module__ZU61ja__icon-color-green",
  "icon-color-light-aqua": "a-list-item-module-scss-module__ZU61ja__icon-color-light-aqua",
  "icon-color-light-berry": "a-list-item-module-scss-module__ZU61ja__icon-color-light-berry",
  "icon-color-light-gray": "a-list-item-module-scss-module__ZU61ja__icon-color-light-gray",
  "icon-color-light-green": "a-list-item-module-scss-module__ZU61ja__icon-color-light-green",
  "icon-color-light-moss": "a-list-item-module-scss-module__ZU61ja__icon-color-light-moss",
  "icon-color-light-red": "a-list-item-module-scss-module__ZU61ja__icon-color-light-red",
  "icon-color-light-smoke": "a-list-item-module-scss-module__ZU61ja__icon-color-light-smoke",
  "icon-color-moss": "a-list-item-module-scss-module__ZU61ja__icon-color-moss",
  "icon-color-orange": "a-list-item-module-scss-module__ZU61ja__icon-color-orange",
  "icon-color-red": "a-list-item-module-scss-module__ZU61ja__icon-color-red",
  "icon-color-smoke": "a-list-item-module-scss-module__ZU61ja__icon-color-smoke",
  "icon-color-white": "a-list-item-module-scss-module__ZU61ja__icon-color-white",
  "icon-small-margin-top": "a-list-item-module-scss-module__ZU61ja__icon-small-margin-top",
  "item": "a-list-item-module-scss-module__ZU61ja__item",
  "paired-item": "a-list-item-module-scss-module__ZU61ja__paired-item",
  "paired-item-dotted-line": "a-list-item-module-scss-module__ZU61ja__paired-item-dotted-line",
  "placeholder": "a-list-item-module-scss-module__ZU61ja__placeholder",
});
